const products = [
  {
    publicId: 'prod/reactivate/hero/unhide-wshadow',
    height: 522,
    mobileHeight: 1,
    alt: 'Unhide Blanket',
  },
  {
    publicId: 'prod/reactivate/hero/glamnetic-wshadow',
    height: 348,
    mobileHeight: 180,
    alt: 'Glamnetic',
  },
  {
    publicId: 'prod/reactivate/hero/bite-wshadow',
    height: 302,
    mobileHeight: 150,
    alt: 'Bite Lipstick',
  },
  {
    publicId: 'prod/reactivate/hero/briogeo-wshadow',
    height: 561,
    mobileHeight: 250,
    alt: 'Briogeo Farewell Fizz',
  },
  {
    publicId: 'prod/reactivate/hero/kate-spade-wshadow',
    height: 466,
    mobileHeight: 240,
    alt: 'Kate Spade Purse',
  },
];

export default products;
